export function TripCardSkeleton() {
  return (
    <div className="bg-white dark:bg-surface-dark-card rounded-xl p-5 shadow-card animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-7 w-48 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-4 w-36 bg-gray-200 dark:bg-gray-700 rounded mt-2" />
          <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded mt-2" />
        </div>
      </div>
    </div>
  );
}
